import { Heading } from "@tokenterminal/core/ui/heading/Heading"
import { ErrorText } from "@tokenterminal/ui/ErrorText"
import { ErrorBoundary } from "components/ErrorBoundary"
import { Suspense } from "react"
import { AsideCard } from "../Aside"
import {
  AsideList,
  AsideListItem,
  AsideListScrollContainer,
} from "../Aside/AsideList"
import { AsideSkeleton } from "../Aside/AsideListSkeletons"
import { useDatasetsList, useDatasetParams } from "./useDatasetsList"
import type { AsideCardProps } from "../Aside/AsideCard"

const DatasetsList = () => {
  const data = useDatasetsList()
  const { slug: pageSlug } = useDatasetParams()

  return (
    <AsideListScrollContainer>
      <AsideList currentPage={pageSlug}>
        {data.map(({ slug, name, description, is_new }) => {
          return (
            <AsideListItem key={slug} href={`/datasets/${slug}`} id={slug}>
              <div className="flex flex-col gap-0.5 py-2">
                <Heading
                  level={4}
                  as={typeof pageSlug !== "string" ? "h2" : "p"}
                  className="!text-xs"
                >
                  {name}
                  {is_new ? (
                    <span className="text-fg-emerald ml-1">(new)</span>
                  ) : null}
                </Heading>
                {description && (
                  <p className="text-xs text-fg-secondary">{description}</p>
                )}
              </div>
            </AsideListItem>
          )
        })}
      </AsideList>
    </AsideListScrollContainer>
  )
}

const DatasetsAsideContent = () => {
  // TODO: use this to implement tabs to select weather to load DatasetsList or PresetsList (to be done)
  return (
    <>
      {/* <AsideFilterRow>
        Tabs here
      </AsideFilterRow> */}
      <ErrorBoundary fallback={<ErrorText>Failed to load datasets</ErrorText>}>
        <Suspense fallback={<AsideSkeleton />}>
          <DatasetsList />
        </Suspense>
      </ErrorBoundary>
    </>
  )
}

export const DatasetsAside = (
  boxProps: Omit<AsideCardProps, "title" | "children">
) => {
  const { slug } = useDatasetParams()

  return (
    <AsideCard
      height="100%"
      isDefaultOpenInMobile={!slug}
      {...boxProps}
      title={
        <Heading
          level={4}
          as={slug ? "p" : "h1"}
          className="!text-xs text-fg-secondary"
        >
          Datasets
        </Heading>
      }
    >
      <DatasetsAsideContent />
    </AsideCard>
  )
}
